/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState } from 'react'

// Images
import download from 'img/snel_download.svg'
import blueprint from 'img/snel_house_blueprint.svg'
import redCross from 'img/snel_red_cross.svg'

// Styles
import 'lightbox-react/style.css'

// Components
import CustomLink from 'components/CustomLink'
import { Paragraph } from 'components/StyledComponents'

// Third Party
import styled from 'styled-components'
import Modal from 'react-modal'
import Slider from 'react-slick'
import Lightbox from 'lightbox-react'
import { size } from 'lodash'
import ReactPlayer from 'react-player'

const ExtraButtonsWrapper = styled.div`
  p {
    font-size: ${(props) => props.theme.font.size.ms};
  }
`

const StyledSlider = styled(Slider)`
  height: 100%;
  width: 100%;

  .slick-list {
    overflow: hidden;
    margin: 0 -15px;
    width: 100%;
  }

  .slick-slide {
    margin: 0 15px;
  }

  .slick-slider {
    padding-left: 40px;
    padding-right: 40px;
  }

  .slick-track {
    display: flex;
  }

  .slick-arrow {
    position: absolute;
  }
`

const StyledModalLink = styled.div`
  transition: transform 0.25s ease;
  border: 2px solid ${(props) => props.theme.color.main};
  width: 264px !important;
  cursor: pointer;
  
  :hover {
    transform: scale(1.05);
  }
`

const StyledCustomLink = styled(CustomLink)`
  transition: transform 0.25s ease;
  border: 2px solid ${(props) => props.theme.color.main};
  width: 264px !important;

  :hover {
    transform: scale(1.05);
  }
`

const Outer = styled.div`
  justify-content: space-between;

  @media (max-width: 991px) {
    flex-wrap: wrap;
  }

  @media (max-width: 767px) {
    justify-content: center;
  }
`

const StyledModal = styled(Modal)`
  position: relative;
`

const CustomStyles = {
  overlay: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: '60'
  }
}

const ModalContent = styled.div``

const InnerModal = styled.div`
  height: 425px;
  width: 675px;
  border-radius: 5px;

  ${ModalContent} {
    height: 415px;
    width: 665px;
  }

  @media (max-width: 767px) {
    height: 225px;
    width: 425px;

    ${ModalContent} {
      height: 175px;
      width: 375px;
    }
  }

  @media (max-width: 575px) {
    height: 225px;
    width: 350px;

    ${ModalContent} {
      height: 175px;
      width: 300px;
    }
  }

  @media (max-width: 350px) {
    height: 225px;
    width: 300px;

    ${ModalContent} {
      height: 175px;
      width: 250px;
    }
  }
`

const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
`

const ImgContainer = styled.div`
  overflow: hidden;
  cursor: pointer;
  height: 100%;
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; 

  img {
    transition: 0.25s;
    height: 100%;
    width: 100%;
  }
  
  :hover {
    img {
      transform: scale(1.2);
    }
  }
`

const PDFDownloadContainer = styled.div`
  width: 100%;
  height: 100%;

  ${StyledCustomLink} {
    width: 200px !important;
  }
`

const CloseButtonContainer = styled.div`
  cursor: pointer;
  top: 10px;
  right: 10px;
  z-index: 100;
`

const CustomButtonWrapper = styled.div``

const StyledRedModalLink = styled.div`
  cursor: pointer;

  ${Paragraph} {
    transition: 0.25s;
    min-width: 264px;
    min-height: 50px;
    text-transform: initial !important;
    border-radius: 59px;
    font-weight: 400;

    :hover {
      background: #242944;
    }
  }
`

const StyledImg = styled.img`
  height: 30px;
  width: 30px;
  transition: 0.25s;

  :hover {
    transform: scale(1.05);
  }
`

const ExtraButtons = ({ setOpen, data, className }) => {
  const [videoIsOpen, videoSetIsOpen] = useState(false)

  const [blueprintsIsOpen, blueprintsSetIsOpen] = useState(false)

  const [mediaData, setMediaData] = useState({
    photoIndex: 0,
    isVisible: false
  })

  let blueList


  if (data.recapWoning.blueprints !== undefined) {
    if (JSON.parse(data.recapWoning.blueprints)) {
      blueList = JSON.parse(data.recapWoning.blueprints[0]).filter((o) => o.indexOf('.pdf') === -1)
    }
  }

  return (
    <ExtraButtonsWrapper className={`${className ? `${className}` : ``}`}>
      <Outer className="d-flex flex-wrap align-items-center">
        <div className="d-flex flex-wrap w-100 justify-content-center align-items-center">
          {data.recapWoning.blueprints !== undefined && blueList.length !== 0 && (
            <>
              <StyledModalLink onClick={() => blueprintsSetIsOpen(true)} className="d-flex my-2 justify-content-center w-100 px-3 py-2">
                <img className="pr-2" src={blueprint} alt="" />
                <Paragraph className="text-uppercase">Plattegrond</Paragraph>
              </StyledModalLink>
              <StyledModal
                isOpen={blueprintsIsOpen}
                onRequestClose={() => blueprintsSetIsOpen(false)}
                style={CustomStyles}
                contentLabel="Video"
              >
                <InnerModal className="color-background-light d-flex justify-content-center align-items-center">
                  <ModalContent className="color-background-secondary-darker d-flex justify-content-center align-items-center">
                    <CloseButtonContainer className="position-absolute" onClick={() => blueprintsSetIsOpen(false)}>
                      <StyledImg src={redCross} alt="" />
                    </CloseButtonContainer>
                    {blueList.length === 1 ? (
                      <ImgContainer>
                        {blueList[0].includes('pdf') ? (
                          <PDFDownloadContainer className="d-flex align-items-center">
                            <StyledCustomLink external newPage to={blueList[0]} className="d-flex my-2 justify-content-center w-100 px-3 py-2">

                              <Paragraph className="text-uppercase">Download</Paragraph>
                            </StyledCustomLink>
                          </PDFDownloadContainer>
                        ) : (
                          <img role="button" tabIndex="0" onKeyPress={() => { }} onClick={() => setMediaData({ photoIndex: 0, isVisible: true })} loading="lazy" src={blueList[0]} alt="" />
                        )}
                      </ImgContainer>
                    ) : (
                      <StyledSlider
                        className="d-flex position-relative align-items-center"
                        infinite
                        speed={1000}
                        slidesToShow={3}
                        slidesToScroll={1}
                        autoplay
                        autoplaySpeed={6000}
                        nextArrow={<div />}
                        prevArrow={<div />}
                        responsive={[
                          {
                            breakpoint: 1199,
                            settings: {
                              slidesToShow: 2
                            }
                          },
                          {
                            breakpoint: 767,
                            settings: {
                              slidesToShow: 1
                            }
                          }
                        ]}
                      >
                        {blueList.map((bluep, index) => (
                          <ImgContainer key={index}>
                            {bluep.includes('pdf') ? (
                              <PDFDownloadContainer className="d-flex align-items-center">
                                <StyledCustomLink external newPage to={bluep} className="d-flex my-2 justify-content-center w-100 px-3 py-2">

                                  <Paragraph className="text-uppercase">Download</Paragraph>
                                </StyledCustomLink>
                              </PDFDownloadContainer>
                            ) : (
                              <img role="button" tabIndex="0" onKeyPress={() => { }} onClick={() => setMediaData({ photoIndex: 0, isVisible: true })} loading="lazy" src={bluep} alt="" />
                            )}
                          </ImgContainer>
                        ))}
                      </StyledSlider>
                    )}

                  </ModalContent>

                  {mediaData.isVisible && (
                    <Lightbox
                      mainSrc={blueList[mediaData.photoIndex]}
                      nextSrc={blueList[(mediaData.photoIndex + 1) % size(blueList)]}
                      prevSrc={
                        blueList[(mediaData.photoIndex + size(blueList) - 1) % size(blueList)]
                      }
                      onCloseRequest={() =>
                        setMediaData({ ...mediaData, ...{ isVisible: false } })}
                      onMovePrevRequest={() =>
                        setMediaData({
                          ...mediaData,
                          ...{
                            photoIndex:
                              (mediaData.photoIndex + size(blueList) - 1) % size(blueList),
                          },
                        })}
                      onMoveNextRequest={() =>
                        setMediaData({
                          ...mediaData,
                          ...{ photoIndex: (mediaData.photoIndex + 1) % size(blueList) },
                        })}
                    />
                  )}
                </InnerModal>
              </StyledModal>
            </>
          )}
          {data.recapWoning.document && data.recapWoning.document !== "Onbekend" && (
            <StyledCustomLink external newPage to={data.meta.document[0]} className="d-flex my-2 justify-content-center w-100 px-3 py-2">
              <img className="pr-2" src={download} alt="" />
              <Paragraph className="text-uppercase">Download</Paragraph>
            </StyledCustomLink>
          )}
          {data.recapWoning.video && data.recapWoning.video !== "Onbekend" && (
            <>
              <StyledModalLink onClick={() => videoSetIsOpen(true)} className="d-flex my-2 justify-content-center w-100 px-3 py-2">
                <img className="pr-2" src={download} alt="" />
                <Paragraph className="text-uppercase">Video</Paragraph>
              </StyledModalLink>
              <StyledModal
                isOpen={videoIsOpen}
                onRequestClose={() => videoSetIsOpen(false)}
                style={CustomStyles}
                contentLabel="Video"
              >
                <InnerModal className="color-background-striking d-flex justify-content-center align-items-center">
                  <ModalContent className="color-background-secondary-darker d-flex justify-content-center align-items-center">
                    {/* <StyledVideo src={data.meta.video[0]} controls autoplay playsInline>
                      <source src={data.meta.video[0]} type="video/mp4" />
                    </StyledVideo> */}
                    <ReactPlayer url={data.recapWoning.video[0]} controls playsinline onError={(e) => console.log(`${data.recapWoning.video[0]} -> Video got a error: ${e}`)} />
                  </ModalContent>
                </InnerModal>
              </StyledModal>
            </>
          )}
        </div>
        <div className="d-flex mt-2 w-100 justify-content-center">
          {data.recapWoning.status === "BESCHIKBAAR" && (
            <>
              <CustomButtonWrapper className={`d-flex ${className ? `${className}` : ``}`}>
                <StyledRedModalLink onClick={() => setOpen(true)}>
                  <Paragraph className="float-left py-2 px-4 d-flex justify-content-center align-items-center color-background-striking color-text-light text-uppercase font-weight-xl font-size-m">Plan een bezichtiging</Paragraph>
                </StyledRedModalLink>
              </CustomButtonWrapper>
            </>
          )}
        </div>
      </Outer>
    </ExtraButtonsWrapper>
  )
}

export default ExtraButtons
